import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { formatServiceLength } from '../../../helpers/serviceLength';
import { ReactComponent as PlayThroughIcon } from '../../../icons/play-through.svg';
import { ReactComponent as CachedIcon } from '../../../icons/clock-rotate-right.svg';

import './ServiceLength.scss';

/** How long a run of songs plays for, as a pill. Shows nothing without a length. */
const ServiceLength = ({ seconds, fromCache = false, className }) => {
  const { t } = useTranslation();

  if (!seconds) return null;

  const title = fromCache ? t('services.lengthCachedTitle') : t('services.lengthTitle');

  return (
    <span className={classNames('ServiceLength', className)} title={title}>
      <PlayThroughIcon aria-hidden="true" />
      {formatServiceLength(seconds)}
      {fromCache && <CachedIcon className="cached-icon" aria-label={t('services.fromSavedCopies')} />}
    </span>
  );
};

ServiceLength.propTypes = {
  /** From totalSeconds; null shows nothing */
  seconds: PropTypes.number,
  fromCache: PropTypes.bool,
  className: PropTypes.string,
};

export default ServiceLength;
